<div>
   <!-- <div *ngIf="isPopupOpen">
      <div (click)="setPopup()" class="overlay"></div>
      <ng-container *ngIf="userRole!=='PREMIUM'">

      </ng-container>
      <ng-container *ngIf="userRole==='PREMIUM'">
         <app-place-order [userRole]="userRole" [symbol]="symbol" [exchangeCode]="exchange" [action]="action">
         </app-place-order>
      </ng-container>
   </div> -->


   <div>
      <div class="action-button_container px-3 px-lg-4">
         <button (click)="handlePopup('BUY')" class="btn text-uppercase text-center d-block action-button rounded-3 gradient-btn text-white fw-500 action-button_buy">
            Buy
         </button>
         <button (click)="handlePopup('SELL')" class="btn text-uppercase text-center d-block action-button rounded-3 text-white fw-500 action-button_sell">
            Sell
         </button>
      </div>
   </div>
</div>

<ng-template #investPlatformPopup let-modal>
   <article class="position-relative promo-container bg-white">
      <button (click)="modal.dismiss('Cross click')" type="button" class="position-absolute text-black top-0 end-0 bg-transparent m-1 m-md-2 border-0 p-1 rounded-3 flex-shrink-0 btn-close-custom">
         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 6 6 18m12 0L6 6"/>
         </svg>
      </button>

      <img src="/assets/images/trade/trading-popup-image.webp" alt="" class="modal-img mx-auto d-block img-fluid">
      
      <div class="modal-text-wrapper text-center">
         <h3 class="mb-3 fw-500">US Investing is now live in Musaffa 🚀</h3>

         <p class="mb-4 lh-base">
            Musaffa has launched its own Shariah-compliant US Investing platform. Would you like to open a free account now? 
         </p>
         
         <div class="d-grid gap-2 gap-md-3 modal-btns-wrapper">
            <button (click)="continueHere(); modal.dismiss('continue')" class="modal-button btn-lg w-100 btn-no rounded-3">
               No, continue with broker
            </button>

            <button (click)="goToHalalInvesting(); modal.dismiss('yes')" class="modal-button btn-lg w-100 btn-yes rounded-3">
               Open Free Account
            </button>
         </div>
      </div>
   </article>
</ng-template>